import React from 'react'
import Testimonial from './SerTab/Testimonial'

const Testimonials = () => {
  const data = [
    {
        "text": "I'm absolutely thrilled with the customized shoes I received from your company! The quick turnaround time exceeded my expectations. Thank you for making my vision a reality!",
        "name": "Aryan Raj"
    },
    {
        "text": "I can't stop raving about the incredible custom shoes I got from you! The attention to detail in the design is phenomenal, and the fact that they arrived so quickly is a pleasant surprise. Kudos to your talented team!",
        "name": "Nikhil Bajwa"
    },
    {
        "text": "A huge shoutout to the Custoshoe team! The personalized shoes I ordered are beyond perfect. The quality is superb, and I'm amazed at how fast they were delivered. You've gained a customer for life!",
        "name": "Siddhant Lamba"
    }
]

  return (
    <div className="bg-black">
      <section
        id="testimonials"
        className="relative block px-6 py-10 md:py-20 md:px-10  border-t border-b border-neutral-900 bg-neutral-900/30"
      >
        <div className="relative mx-auto max-w-5xl text-center">
          <span className="text-gray-400 my-3 flex items-center justify-center font-medium uppercase tracking-wider">
            Testimonials and Reviews
          </span>
          <h2 className="block w-full bg-gradient-to-b from-white to-gray-400 bg-clip-text font-bold text-transparent text-3xl sm:text-4xl">
            Get a shoe that Embraces your personality
          </h2>
        </div>

        <div className="relative mx-auto max-w-7xl z-10 grid grid-cols-1 gap-10 pt-14 sm:grid-cols-2 lg:grid-cols-3">
          {/* Customizable Feature */}
          {data.map((item,i)=>{
            return <Testimonial item ={item} key={i}/>
          })}

          {/* Fast Performance Feature */}
          {/* ... Fill similar components here ... */}
        </div>

        <div className="absolute bottom-0 left-0 z-0 h-1/3 w-full border-b" style={{ backgroundImage: 'linear-gradient(to right top, rgba(79, 70, 229, 0.2) 0%, transparent 50%, transparent 100%)', borderColor: 'rgba(92, 79, 240, 0.2)' }}></div>
        <div className="absolute bottom-0 right-0 z-0 h-1/3 w-full" style={{ backgroundImage: 'linear-gradient(to left top, rgba(220, 38, 38, 0.2) 0%, transparent 50%, transparent 100%)', borderColor: 'rgba(92, 79, 240, 0.2)' }}></div>
      </section>
    </div>
  )
}

export default Testimonials